module.exports = __webpack_public_path__ + "img/loader-dots.3e3a718c.svg";